export const setItem = ({ key = '', value = '' }) => {
  if (key && value) {
    localStorage.setItem(key, value);
    return true;
  }

  return false;
};

export const setPrevUrl = ({ key = 'prev_url', url = '' }) => {
  localStorage.setItem(key, url);
};

export const removePrevUrl = ({ key = 'prev_url' }) => {
  localStorage.removeItem(key);
};

export const getItem = ({ name = 'access_token' }) => {
  if (typeof window !== 'undefined') {
    return localStorage?.getItem(name) ?? '';
  }
};

export function getItemSession({ key = 'access_token' }) {
  return sessionStorage?.getItem(key) ?? '';
}

export function setItemSession({ key, value }) {
  if (key && value) {
    sessionStorage.setItem(key, value);
    return true;
  }

  return false;
}

// cache using session storage
// Menyimpan data dengan TTL di sessionStorage
export const setItemSessionWithTTL = ({ key, value, ttl }) => {
  const now = new Date();
  const item = {
    value,
    expiry: now.getTime() + ttl,
  };
  sessionStorage.setItem(key, JSON.stringify(item));
};

// Mengambil data dari sessionStorage dan mengecek TTL
export const getItemSessionWithTTL = ({ key }) => {
  const itemStr = sessionStorage.getItem(key);
  if (!itemStr) return null;

  const item = JSON.parse(itemStr);
  const now = new Date();

  if (now.getTime() > item.expiry) {
    sessionStorage.removeItem(key);
    return null;
  }

  return item.value;
};
